import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Navbar } from './components/Navbar';
import { BentoPortfolio } from './components/bento/BentoGrid';
import type { Variant } from './data/variants';
import './App.css';

export type Lang = 'en' | 'es';
export type { Variant } from './data/variants';

function App() {
  const [lang, setLang] = useState<Lang>('en');
  const [variant, setVariant] = useState<Variant>('security');
  return (
    <div className="app">
      <Navbar lang={lang} setLang={setLang} variant={variant} setVariant={setVariant} />
      <AnimatePresence mode="wait">
        <motion.div
          key={`${lang}-${variant}`}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.25 }}
        >
          <BentoPortfolio lang={lang} variant={variant} />
        </motion.div>
      </AnimatePresence>
      <footer className="footer">
        <p>&copy; {new Date().getFullYear()} Jordan Rivera Rodriguez</p>
        <p className="footer-built">Built with React, TypeScript & Framer Motion</p>
      </footer>
    </div>
  );
}

export default App;
